/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

/**
 * 動画評価送信のレスポンス
 */
export interface SubmitVideoFeedbackResponse {
  /** 成功フラグ */
  success: boolean
}
